export default {"src":"/_next/static/media/freeleticsLogo.bbbebf90.svg","height":16,"width":26,"blurWidth":0,"blurHeight":0};